import styled from 'styled-components';

const H1 = styled.h1`
  font-size: 1.5rem;
  line-height: 1.25;
  margin: 0 0 1rem;

  @media (min-width: 1000px) {
    font-size: 2rem;
  }
`;

const BigH2 = styled.h2`
  font-size: 1.25rem;
  line-height: 1.25;

  @media (min-width: 800px) {
    font-size: 1.5rem;
  }
`;

const H2 = styled.h2`
  font-size: 1rem;
  line-height: 1.5;

  @media (min-width: 500px) {
    font-size: 1.25rem;
    line-height: 1.25;
  }

  @media (min-width: 1000px) {
    font-size: 1.5rem;
  }
`;

const H3 = styled.h3`
  /* font-size: 0.8125rem; */
  font-size: 0.875rem;
  line-height: 1rem;

  @media (min-width: 500px) {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

const P = styled.p`
  font-size: 1rem;
  line-height: 1.5;
`;

const Caption = styled.p`
  font-size: 0.8125rem;
  line-height: 1rem;
`;

export { H1, BigH2, H2, H3, P, Caption };
